/* 15 Oct product page tidy-up (Claude). Product pages only.
   1. "Size chart" link next to the size buttons, opening a pop-up with the product's own size table.
   2. Long descriptions turned into a short intro + tap-to-open sections (Details, Size & fit, Care,
      Delivery & returns, Questions). Nothing is deleted: every word stays on the page for Google.
   3. Old returns wording in descriptions swapped for wording that matches the refund policy (on screen only).
   To undo: remove the pdp-premium lines in snippets/meta-tags.liquid. */
(function () {
  'use strict';
  var P = window.SWW_PDP || {};
  var TYPE = (P.type || '').toLowerCase();
  var TMPL = (P.tmpl || '').toLowerCase();
  var MADE_TO_ORDER = /t-?shirt|tee|hoodie|sweatshirt|mug/.test(TYPE) || /^(pod|pod-hoodie|mug|personalized)$/.test(TMPL);

  var POLICY_MTO = "Made to order, so we can't take it back if you change your mind or pick the wrong size. Please check the size chart before ordering. If it arrives faulty, damaged or wrong, tell us within 30 days and we'll replace or refund it.";
  var POLICY_RM = "Changed your mind? If you're in the UK or EU, tell us within 14 days of delivery and send it back unused in its original packaging (return postage is at your cost). If it arrives faulty, damaged or wrong, tell us within 30 days and we'll replace or refund it.";

  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* ---------- returns wording (on screen only) ---------- */
  function fixReturns(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false), n, list = [];
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) {
      var v = t.nodeValue;
      if (/returns are free within 30 days/i.test(v)) {
        t.nodeValue = v.replace(/\s*[.—-]\s*returns are free within 30 days for unused items in original condition\.?/i,
          MADE_TO_ORDER ? ". As it's made to order there are no change-of-mind returns, but faulty, damaged or wrong items are covered for 30 days." : ". " + POLICY_RM);
      } else if (/^\s*30-day returns\s*$/i.test(v)) {
        t.nodeValue = v.replace(/30-day returns/i, '30-day faulty cover');
      }
    });
  }

  /* ---------- size table helpers ---------- */
  function isSizeTable(t) {
    var s = txt(t).toLowerCase();
    if (/^spec/.test(s)) return false;
    if (!/(chest|width|length|waist|neck|back|weight|dimension|capacity|height)/.test(s)) return false;
    return /\b(xs|s|m|l|xl|2xl|xxl|3xl|small|medium|large)\b/i.test(s) || /\d/.test(s);
  }
  /* Some tee tables say "Chest" but list the width laid flat (e.g. M = 51 cm). Label them properly. */
  function relabelChest(t) {
    var rows = [].slice.call(t.rows || []);
    rows.forEach(function (r, ri) {
      [].slice.call(r.cells).forEach(function (c, ci) {
        if (!/^chest\b/i.test(txt(c)) || /width|flat|circ/i.test(txt(c))) return;
        var nums = [];
        if (ri === 0) rows.slice(1).forEach(function (rr) { var x = parseFloat(txt(rr.cells[ci] || {textContent: ''})); if (!isNaN(x)) nums.push(x); });
        else [].slice.call(r.cells).slice(1).forEach(function (cc) { var x = parseFloat(txt(cc)); if (!isNaN(x)) nums.push(x); });
        if (!nums.length) return;
        nums.sort(function (a, b) { return a - b; });
        var mid = nums[Math.floor(nums.length / 2)];
        var inches = /\bin\b|inch|"/i.test(txt(c)) || mid < 35;
        if ((inches && mid < 30) || (!inches && mid < 75)) c.textContent = txt(c).replace(/^chest/i, 'Chest width (laid flat)');
      });
    });
  }

  /* ---------- description: intro + tap-to-open sections ---------- */
  function classify(el) {
    var tag = el.tagName;
    if (tag === 'TABLE') return isSizeTable(el) ? 'size' : 'details';
    var head = '';
    if (tag === 'DETAILS') { var s = el.querySelector('summary'); head = s ? txt(s) : txt(el).slice(0, 80); }
    else {
      var h = el.querySelector('h1,h2,h3,h4,h5,strong,b');
      head = (/^H[1-6]$/.test(tag) ? txt(el) : (h ? txt(h) : txt(el).slice(0, 60)));
    }
    var hl = head.toLowerCase();
    if (/^h[1-6]$/i.test(tag) && /question|faq|good to know|answers/.test(hl)) return 'faqhead';
    if (/deliver|shipping|ship |arrive|dispatch|return|refund|exchange|tracking/.test(hl)) return 'delivery';
    if (/^(care|washing|wash|how (do|to) (i )?(care|wash|clean))|dishwasher|microwave|care instructions|how do i care/.test(hl)) return 'care';
    if (/^(size|sizing|fit\b|measure)|what size|which size|size guid|size chart|fit guide|measurements are/.test(hl)) return 'size';
    if (tag === 'DETAILS') return 'faq';
    return 'details';
  }

  function makeAcc(title, nodes, extraTop) {
    var d = document.createElement('details');
    d.className = 'sww-acc';
    var s = document.createElement('summary');
    s.textContent = title;
    d.appendChild(s);
    var b = document.createElement('div');
    b.className = 'sww-acc-body';
    if (extraTop) b.appendChild(extraTop);
    nodes.forEach(function (n) { b.appendChild(n); });
    d.appendChild(b);
    return d;
  }

  function structure(desc) {
    if (desc.dataset.swwStructured) return null;
    var root = desc;
    while (root.children.length === 1 && root.firstElementChild.children.length > 0 && root.firstElementChild.tagName !== 'TABLE') root = root.firstElementChild;
    var kids = [].slice.call(root.children);
    if (kids.length < 4 && txt(desc).length < 900) return null; /* short description: leave as is */

    var intro = [], i = 0;
    for (; i < kids.length && i < 7; i++) {
      var k = kids[i];
      if (/^(TABLE|DETAILS|H2|H3)$/.test(k.tagName)) break;
      if (k.tagName !== 'P' && txt(k).length > 220) break; /* a full feature section */
      intro.push(k);
      if (k.tagName === 'P' && txt(k).length >= 150) { i++; break; }
    }
    var groups = { details: [], size: [], care: [], delivery: [], faq: [] };
    kids.slice(i).forEach(function (k) {
      var c = classify(k);
      if (c === 'faqhead') { groups.faq.push(k); return; }
      groups[c].push(k);
    });

    var wrap = document.createDocumentFragment();
    var introBox = document.createElement('div');
    introBox.className = 'sww-intro';
    intro.forEach(function (n) { introBox.appendChild(n); });
    wrap.appendChild(introBox);

    if (groups.details.length) wrap.appendChild(makeAcc('Details', groups.details));
    var sizeAcc = null;
    if (groups.size.length) { sizeAcc = makeAcc('Size & fit', groups.size); wrap.appendChild(sizeAcc); }
    if (groups.care.length) wrap.appendChild(makeAcc('Care', groups.care));

    /* a description question called "Delivery & returns" inside our own "Delivery & returns" section: show its text directly */
    groups.delivery = groups.delivery.map(function (n) {
      if (n.tagName !== 'DETAILS') return n;
      var sm = n.querySelector('summary');
      if (!sm || !/^delivery\s*(&|and)\s*returns\??$/i.test(txt(sm))) return n;
      var box = document.createElement('div');
      [].slice.call(n.childNodes).forEach(function (c) { if (c !== sm) box.appendChild(c); });
      return box;
    });
    var pol = document.createElement('div');
    pol.className = 'sww-policy';
    pol.innerHTML = '<p></p><p></p><p><a href="/policies/refund-policy">Full returns policy</a> · <a href="/policies/shipping-policy">Delivery details</a></p>';
    pol.children[0].textContent = MADE_TO_ORDER
      ? 'Free tracked delivery. Made to order, then shipped: usually with you in 3-5 working days (further-away countries can take a little longer).'
      : 'Free tracked delivery. Usually with you in 4-7 working days (further-away countries can take a little longer).';
    pol.children[1].textContent = MADE_TO_ORDER ? POLICY_MTO : POLICY_RM;
    wrap.appendChild(makeAcc('Delivery & returns', groups.delivery, pol));

    var faqHasQs = groups.faq.some(function (n) { return n.tagName === 'DETAILS' || n.querySelector('details'); });
    if (groups.faq.length && faqHasQs) wrap.appendChild(makeAcc('Questions', groups.faq));

    root.innerHTML = '';
    root.appendChild(wrap);
    desc.dataset.swwStructured = '1';
    desc.classList.add('sww-structured');
    return { sizeAcc: sizeAcc };
  }

  /* ---------- size chart pop-up ---------- */
  var RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="1.5"/><path d="M6 7v4M10 7v3M14 7v4M18 7v3"/></svg>';

  function sizeChart(desc, sizeAcc) {
    var fs = [].slice.call(document.querySelectorAll('.product__info .product__option')).filter(function (f) {
      var l = f.querySelector('.product__option-label');
      return l && /^\s*sizes?\b/i.test(txt(l));
    })[0];
    if (!fs || fs.querySelector('.sww-sc-link')) return;
    var table = [].slice.call(desc.querySelectorAll('table')).filter(isSizeTable)[0];
    if (!table) return;
    /* pet clothing with the breed table already uses the Vitals size chart: leave those alone */
    if (/typical breeds/i.test(txt(table))) return;
    relabelChest(table);

    var dlg = document.createElement('dialog');
    dlg.className = 'sww-sc-dialog';
    dlg.setAttribute('aria-labelledby', 'sww-sc-title');
    dlg.innerHTML = '<div class="sww-sc-head"><h2 id="sww-sc-title">Size chart</h2><button type="button" class="sww-sc-close" aria-label="Close size chart">&times;</button></div><div class="sww-sc-body"><div class="sww-sc-scroll"></div></div>';
    var body = dlg.querySelector('.sww-sc-body');
    var scroll = dlg.querySelector('.sww-sc-scroll');
    /* keep the table in the description (for Google) and show a copy in the pop-up */
    var copy = table.cloneNode(true);
    copy.removeAttribute('style');
    [].slice.call(copy.querySelectorAll('[style],[class],[width],[bgcolor]')).forEach(function (e) {
      e.removeAttribute('style'); e.removeAttribute('class'); e.removeAttribute('width'); e.removeAttribute('bgcolor');
    });
    scroll.appendChild(copy);
    var hasWidth = /width|flat/i.test(txt(scroll));
    var note = document.createElement('p');
    note.className = 'sww-sc-note';
    note.textContent = hasWidth
      ? 'Width is measured flat across the chest, armpit to armpit. Length is measured from the top of the shoulder to the hem. Measurements can vary by about 2-3 cm.'
      : 'Measurements are approximate and can vary slightly.';
    body.appendChild(note);
    if (MADE_TO_ORDER) {
      var warn = document.createElement('p');
      warn.className = 'sww-sc-warn';
      warn.textContent = 'Tip: lay a top that fits you well flat and measure it, then pick the closest size. As this is made to order, we can\'t swap sizes after ordering.';
      body.appendChild(warn);
    }
    document.body.appendChild(dlg);

    function open(e) {
      if (e) e.preventDefault();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    }
    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    dlg.querySelector('.sww-sc-close').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'sww-sc-link';
    link.innerHTML = RULER + '<span>Size chart</span>';
    link.addEventListener('click', open);
    var legend = fs.querySelector('.product__option-label');
    legend.classList.add('sww-has-sc');
    legend.appendChild(link);

    /* (15 Oct: removed the extra "Open the size chart" button inside Size & fit - the table is already shown there) */

    /* If a Vitals size chart button also shows up, keep only one link */
    var info = document.querySelector('.product__info');
    function dedupe() {
      var other = [].slice.call(info.querySelectorAll('[class*="vtl"] *, [class*="vitals"] *')).filter(function (e) {
        if (e.closest('.product__description, .sww-sc-link, .sww-sc-dialog, .sww-acc')) return false;
        return e.children.length === 0 && /^\s*size\s*(chart|guide)s?\s*$/i.test(e.textContent || '') && e.getBoundingClientRect().height > 0;
      });
      if (other.length) link.style.display = 'none';
    }
    if (window.MutationObserver && info) {
      var mo = new MutationObserver(dedupe);
      mo.observe(info, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
    dedupe();
  }


  /* ---------- computer screens: one big photo + thumbnails (no tall photo grid) ----------
     18 Oct fix: when a colour was picked, the theme marked the new colour's photo as the big photo while it was
     still hidden from the previous colour, so this gallery thought no photo was showing and jumped back to the
     first photo (e.g. the black dog photo). Now it only picks the first photo when NO photo at all is marked. */
  function deskGallery() {
    var list = document.querySelector('.product__media-list');
    if (!list || list.children.length < 2 || list.dataset.swwGal) return;
    list.dataset.swwGal = '1';
    var wrap = list.parentNode;
    wrap.classList.add('sww-gal');
    var strip = document.createElement('div');
    strip.className = 'sww-thumbs';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'sww-gal-arrow sww-gal-prev'; prev.setAttribute('aria-label', 'Previous photo'); prev.innerHTML = '&#8249;';
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'sww-gal-arrow sww-gal-next'; next.setAttribute('aria-label', 'Next photo'); next.innerHTML = '&#8250;';
    wrap.appendChild(prev); wrap.appendChild(next); wrap.appendChild(strip);
    function items() {
      return [].filter.call(list.children, function (x) {
        return x.classList.contains('product__media-item') && x.style.display !== 'none';
      });
    }
    function activate(el) {
      [].forEach.call(list.children, function (x) { x.classList.toggle('is-active', x === el); });
    }
    function step(d) {
      var it = items(), i = it.findIndex(function (x) { return x.classList.contains('is-active'); });
      if (!it.length) return;
      activate(it[(i + d + it.length) % it.length]);
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    /* 27 Oct: when the page opens, show the photo that belongs to the colour/option that is already selected
       (e.g. Black selected = black photo first, not the first photo in the list). */
    function startOnSelectedPhoto() {
      var dataEl = document.querySelector('script[data-variants-json]');
      if (!dataEl) return;
      var vs;
      try { vs = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var sel = [].map.call(document.querySelectorAll('.product__option'), function (fs) {
        var c = fs.querySelector('input[type="radio"]:checked');
        return c ? c.value : null;
      });
      var m = vs.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (!m || !m.media) return;
      var t = list.querySelector('.product__media-item[data-media-id="' + m.media + '"]');
      if (t) activate(t);
    }
    try { startOnSelectedPhoto(); } catch (e) {}
    var busy = false;
    function render() {
      if (busy) return; busy = true;
      var it = items();
      var anyOn = [].some.call(list.children, function (x) { return x.classList.contains('is-active'); });
      if (it.length && !anyOn) activate(it[0]);
      strip.innerHTML = '';
      it.forEach(function (el) {
        var img = el.querySelector('img');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sww-thumb' + (el.classList.contains('is-active') ? ' is-on' : '');
        b.setAttribute('aria-label', 'Show photo');
        if (img) { var t = document.createElement('img'); t.src = img.currentSrc || img.src; t.alt = ''; t.loading = 'lazy'; b.appendChild(t); }
        else { b.textContent = '▶'; }
        b.addEventListener('click', function () { activate(el); });
        strip.appendChild(b);
      });
      var on = it.filter(function (x) { return x.classList.contains('is-active'); })[0];
      var show = it.length > 1 ? '' : 'none';
      prev.style.display = next.style.display = strip.style.display = show;
      if (on) { var h = on.offsetHeight; prev.style.top = next.style.top = Math.max(40, h / 2 - 22) + 'px'; }
      busy = false;
    }
    var tmr;
    function later() { clearTimeout(tmr); tmr = setTimeout(render, 60); }
    if (window.MutationObserver) new MutationObserver(later).observe(list, { attributes: true, subtree: true, attributeFilter: ['class', 'style'], childList: true });
    window.addEventListener('load', later);
    render();
  }

  function run() {
    var desc = document.querySelector('.product__info .product__description, .product__description');
    if (!desc) return;
    try { fixReturns(desc); } catch (e) {}
    var res = null;
    try { res = structure(desc); } catch (e) {}
    try { sizeChart(desc, res && res.sizeAcc); } catch (e) {}
  }
  function runGallery() { try { deskGallery(); } catch (e) {} }

  /* 15 Oct: Danny asked for the Vitals "Buy more, save more" box to sit BELOW Add to Cart
     (just under the delivery line). Only moves it on the page - no Vitals settings changed.
     Undo: delete this offerBelow block. */
  function offerBelow() {
    var info = document.querySelector('.product__info');
    if (!info || !window.MutationObserver) return;
    var css = document.createElement('style');
    css.textContent = '.product__buy-form > .vtl-ub-vd-widget{margin:6px 0 0 !important}';
    document.head.appendChild(css);
    function place() {
      var vd = info.querySelector('.vtl-ub-vd-widget');
      var form = info.querySelector('.product__buy-form');
      var btn = form && form.querySelector('.product__buy-button');
      if (!vd || !btn) return;
      var after = form.querySelector('.sww-eta') || btn;
      if (after.nextElementSibling === vd) return;
      after.insertAdjacentElement('afterend', vd);
    }
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(place, 50); }).observe(info, { childList: true, subtree: true });
    place();
  }
  function runOffer() { try { offerBelow(); } catch (e) {} }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); document.addEventListener('DOMContentLoaded', runGallery); document.addEventListener('DOMContentLoaded', runOffer); } else { run(); runGallery(); runOffer(); }
})();
